import { axiosInstance } from "./config";
import { useQuery } from "@tanstack/react-query";

export const useSupplierBusinessTypes = () => {
  return useQuery({
    queryKey: ["supplier-business-types"],
    queryFn: () => axiosInstance.get("supplier-business-types"),
  });
};
